import { inject } from '@angular/core';
import { Router, CanMatchFn } from '@angular/router';
import { UserDataService } from '../services/user-data/user-data.service';
import { RoutesEnum } from '../routing/routes.enum';
import { RolesEnum } from '../types/enums/roles-state.enum';

export const trainingRoleGuard: CanMatchFn = (route, segments) => {
	const router = inject(Router);
	const userDataService = inject(UserDataService);

	if (!userDataService.doesUserHaveRole(RolesEnum.Trained)) {
		router.navigate([RoutesEnum.blankPage]);
	}
	return true;
};
